import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdministrationComponent } from './administration.component';
import { FunctionMasterComponent } from './function-master/function-master.component';
import { ComponentMasterComponent } from './component-master/component-master.component';
import { RegulatoryGroupMasterComponent } from './regulatory-group-master/regulatory-group-master.component';
import { PropertyMasterComponent } from './property-master/property-master.component';
import { LeadContactsManagementComponent } from './lead-contacts-management/lead-contacts-management.component';
import { SelfAssessmentComponent } from './self-assessment/self-assessment.component';

const routes: Routes = [
  {
    path: '',
    component: AdministrationComponent,
    children: [
      {
        path: 'component-master',
        component: ComponentMasterComponent
      },
      {
        path: 'function-master',
        component: FunctionMasterComponent
      },
      {
        path: 'regulatory-group-master',
        component: RegulatoryGroupMasterComponent
      },
      {
        path: 'property-master',
        component: PropertyMasterComponent
      },
      {
        path: 'lead-contacts-management',
        component: LeadContactsManagementComponent
      },
      {
        path: 'self-assessment',
        component: SelfAssessmentComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdministrationRoutingModule { }
